/*
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file has been auto-generated. Any modifications
 * you make will be overwritten when the file is regenerated.
 *
 * For more information or questions, please go to #design-eng
 *
 */

/*
 * Base 2.0 Corner Radius Tokens
 * =============================
 *
 * A single primitive ramp shared across the design system. Corner radius has
 * no light/dark modes, so there is one set of values, keyed in camelCase
 * (radius6 … radiusFull) and ready to drop onto a JS theme (e.g.
 * theme.cornerRadius.radius12) without any per-consumer key remapping — the
 * corner-radius analogue of elevationTokensV2* / elevationTokensV2CssVars.
 *
 *   cornerRadiusTokensV2        — literal px values (JS path; no CSS file needed)
 *   cornerRadiusTokensV2CssVars — var(--base-corner-radius-*) references (CSS path)
 *
 * The CSS custom properties themselves live in base-corner-radius-v2.css
 * (--base-corner-radius-6 … --base-corner-radius-full).
 *
 * radiusFull is 1000px — the Figma source uses this large value to fake full
 * roundness; it is preserved verbatim as the source-of-truth value.
 */

export const cornerRadiusTokensV2 = ({
  radius6: '6px',
  radius8: '8px',
  radius12: '12px',
  radius16: '16px',
  radius24: '24px',
  radius32: '32px',
  radiusFull: '1000px'
} as const);
export type CornerRadiusTokensV2Type = typeof cornerRadiusTokensV2;
export const cornerRadiusTokensV2CssVars = ({
  radius6: 'var(--base-corner-radius-6)',
  radius8: 'var(--base-corner-radius-8)',
  radius12: 'var(--base-corner-radius-12)',
  radius16: 'var(--base-corner-radius-16)',
  radius24: 'var(--base-corner-radius-24)',
  radius32: 'var(--base-corner-radius-32)',
  radiusFull: 'var(--base-corner-radius-full)'
} as const);
export type CornerRadiusTokensV2CssVarsType = typeof cornerRadiusTokensV2CssVars;